import { render, staticRenderFns } from "./spcodaccount.vue?vue&type=template&id=fc738c50"
import script from "./spcodaccount.vue?vue&type=script&lang=js"
export * from "./spcodaccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports